import { render, staticRenderFns } from "./CardWithHelp.vue?vue&type=template&id=86a4bd94&scoped=true&"
import script from "./CardWithHelp.vue?vue&type=script&lang=js&"
export * from "./CardWithHelp.vue?vue&type=script&lang=js&"
import style0 from "./CardWithHelp.vue?vue&type=style&index=0&id=86a4bd94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86a4bd94",
  null
  
)

export default component.exports